/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_UpgradeInputs */

const en_coaching_upgrade = /** @type {(inputs: Coaching_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See plans`)
};

const id_coaching_upgrade = /** @type {(inputs: Coaching_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat paket`)
};

/**
* | output |
* | --- |
* | "See plans" |
*
* @param {Coaching_UpgradeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_upgrade = /** @type {((inputs?: Coaching_UpgradeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_UpgradeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_upgrade(inputs)
	return en_coaching_upgrade(inputs)
});